// Port of api/fuel/app/classes/controller/api/monty/app/notifications.php
import DB from 'offline/db'
export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id')
	var now = Math.floor(Date.now() / 1000)
	var notifications = DB.query('SELECT * FROM notification WHERE notification_date < ? AND (user_id = ? OR user_id IS NULL OR user_id = 0) ORDER BY notification_date DESC LIMIT 25', [now, userId || 0])

	if (userId && notifications.length) {
		DB.run('UPDATE user SET user_date_notifications = ? WHERE user_id = ?', [notifications[0].notification_date || notifications[0].date || 0, userId])
		return DB.save().then(function() {
			return {
				session: { offline: true },
				data: { notifications: notifications }
			}
		})
	}

	return Promise.resolve({ session: { offline: true }, data: { notifications: notifications } })
}
